// src/utils/commonUtils.js

export const STATE_OPTIONS = [
    { label: "Johor", value: "JO" },
    { label: "Kedah", value: "KD" },
    { label: "Kelantan", value: "KN" },
    { label: "Melaka", value: "ML" },
    { label: "Negeri Sembilan", value: "NS" },
    { label: "Pahang", value: "PH" },
    { label: "Perak", value: "PK" },
    { label: "Perlis", value: "PS" },
    { label: "Pulau Pinang", value: "PP" },
    { label: "Sabah", value: "SB" },
    { label: "Sarawak", value: "SW" },
    { label: "Selangor", value: "SL" },
    { label: "Terengganu", value: "TG" },
    { label: "Kuala Lumpur", value: "KL" },
    { label: "Putrajaya", value: "PJ" },
    { label: "Labuan", value: "LB" },
];

export const generateUserId = (role, name) => {
    const prefix = role === "teacher" ? "T" : "S";
    const now = new Date();
    const timestamp = `${now.getFullYear().toString().slice(2)}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
    const cleanName = name.trim().split(" ")[0].toUpperCase();
    return `${prefix}${timestamp}${cleanName}`;
};

export const generateSchoolId = (stateCode, schoolName) => {
    const now = new Date();
    const timestamp = `${now.getFullYear().toString().slice(2)}${String(now.getMonth() + 1).padStart(2, "0")}${String(now.getDate()).padStart(2, "0")}${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;
    const namePart = schoolName
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase())
        .join("");
    return `${stateCode}${timestamp}${namePart}`;
};

export const toTitleCase = (str) => {
    return str
        .toLowerCase()
        .split(" ")
        .filter(Boolean)
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
};

export const generateClassroomId = (classroomName) => {
    const now = new Date();
    const timestamp = `${String(now.getDate()).padStart(2, "0")}${String(now.getMonth() + 1).padStart(2, "0")}${now.getFullYear().toString().slice(2)}${String(now.getHours()).padStart(2, "0")}${String(now.getMinutes()).padStart(2, "0")}${String(now.getSeconds()).padStart(2, "0")}`;

    const namePart = classroomName
        .trim()
        .toUpperCase()
        .replace(/\s+/g, ""); // remove spaces

    return `${namePart}${timestamp}`;
};

export const getInitials = (name) => {
    if (!name) return "";
    const parts = name.trim().split(" ");
    const first = parts[0]?.[0] || "";
    const second = parts[1]?.[0] || "";
    return (first + second).toUpperCase();
};


export const customStyles = {
    container: (provided) => ({
        ...provided,
        width: "100%", // atau '100%', 'auto', dsb.
    }),
    control: (base, state) => ({
        ...base,
        borderRadius: "8px",
        borderColor: state.isFocused ? "#000" : "#ddd",
        boxShadow: state.isFocused ? "0 0 0 1px #000" : "none",
        padding: "5px",
    }),
    placeholder: (base) => ({
        ...base,
        textAlign: "left",
        color: "#aaa",
    }),
    menu: (base) => ({
        ...base,
        textAlign: "left",
    }),
    option: (base, state) => ({
        ...base,
        textAlign: "left",
        backgroundColor: state.isFocused ? "#f5f5f5" : "white",
        color: "#333",
    }),
};




